import {Dispatch} from 'redux';
import {makeUrl, post} from '../../utils/fetcher';
import {METHODS} from '../../constants';

export const recoverTOTP = (
  recoveryCode: string,
  // eslint-disable-next-line no-unused-vars
  callback: (result: boolean) => void,
) => {
  const path = METHODS.RECOVER_TOTP;
  const url = makeUrl(path);
  return (dispatch: Dispatch) =>
    post(url, {recoveryCode}, dispatch, false)
      .then((response) =>
        callback(!!response?.success),
      )
      .catch(() => callback(false));
};
